export const ICON_SIZE = 18;
export const BUTTON_SIZE = 28;
export const FONT_SIZE = 12;
